import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import SectionGroupWrapper from 'components/digitalTemplates/SectionGroupWrapper'
import SortableSectionsWrapper from 'agency/digital_renderer/components/SortableSectionsWrapper'

import Section from './Section'
import styles from './styles.scss'

const sortSections = sectionArray => sectionArray.sort((a, b) => {
  const sortA = a.options ? a.options.sort : 0
  const sortB = b.options ? b.options.sort : 0

  return sortA > sortB ? 1 : -1
})

const registerComponents = (sections, options) => {
  const { callbacks } = options

  const sorted = sortSections(sections)

  return sorted
    .map(section => section && <Section key={section.id} callbacks={callbacks} section={section} />)
    .filter(section => section)
}

const SectionGroup = (props) => {
  const { callbacks, sectionGroup } = props

  const { sticky, sortable } = sectionGroup.options || {}

  const isSortable = sortable

  return (
    <SectionGroupWrapper
      sectionGroup={sectionGroup}
      render={({ sections }) => (
        <div className={classnames(styles.root, sticky ? styles.sticky : null)}>
          <SortableSectionsWrapper
            components={registerComponents(sections, { callbacks })}
            isSortable={isSortable}
            render={({ sortedComponents }) => sortedComponents.map(section => section)}
          />
        </div>
      )}
    />
  )
}

SectionGroup.propTypes = {
  callbacks: PropTypes.object.isRequired,
  sectionGroup: PropTypes.object.isRequired,
}

export default SectionGroup
